import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';

/**
 * The PR page's scroll container, shared by the PR layout and the navigation
 * loading overlay so both paint content at the same inset and width.
 *
 * Only the layout passes `id="scrollable-content"`: scroll code looks the
 * container up by that id, and the overlay can be on screen above a mounted
 * PR page.
 */
export function PrV2ScrollableContent(t0) {
  const $ = _c(4);
  const {
    id,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      scrollbarGutter: "stable"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== id) {
    t2 = <div id={id} className="custom-scrollbar flex size-full min-w-0 flex-1 flex-col overflow-y-auto pl-1 pr-0 pb-[calc(var(--pr-v2-mobile-action-bar-height,0px)+4rem)] text-sm md:pl-4 md:pr-0" style={t1}>{children}</div>;
    $[1] = children;
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}